<template>
    <div class="full-bleed">
        <section  class="full-bleed login" v-bind:class="{ logofull: backgroundImage, 'bg-important': !backgroundImage }" v-bind:style="{ backgroundImage: 'url(' + backgroundImage + ')' }" >
            <Errors :errorMessage="errorMessage"></Errors>
            <div class="delhivery-logo-wrapper" v-show="!showLoading">
                <div class="logo"></div>
                <h1>
                  Delhivery
                </h1>
            </div>
            <div class="login-wrapper" v-show="!showLoading">
                <change-password
                    v-on:goToPage="goToPage($event)"
                    :userErrorInfo="userErrorInfo"
                    :redirectTime= "redirectTime"
                ></change-password>

                <div class="login-form-section">
                    <div class="login-outer-container" v-show="!showLoading">
                        <div class="card login-container">
                            <loader v-if="isLoading || ( !umsConfigSet)"></loader>
                            <h4 class="login-title" v-if="!isLoading && defaultView !== 'forgot' && !invalidUrl">SIGN IN</h4>
                            <div class="login-partials fullbleed-height" v-bind:class="{ forgotPass : defaultView == 'forgot' }">
                                <div class="">

                                    <div class="partials-inner" v-show="!isLoading">
                                        <div v-show="!invalidUrl && umsConfigSet" class="partials" >
                                            <forgot-password v-show="defaultView === 'forgot' && showForgotPassword"
                                                        :needForgotPasswordLogin="showForgotPassword"
                                                        :phoneNumorEmailSuccess="phoneNumorEmailSuccess"
                                                        v-on:forgotPassword="forgotPassword($event)"
                                                        :phoneNumberEmailSuccess="phoneNumberEmailSuccess">
                                            </forgot-password>

                                            <local-login v-show="defaultView === 'password' && showlogin"
                                                        :needPasswordLogin="passwordView"
                                                        v-on:localLogin="localLogin($event)"
                                                        v-on:selectedLoginMethod="showAltForm">
                                            </local-login>
                                            <div>
                                                <google-login v-show="(defaultView === 'google' || defaultView === 'otp') && showGoogle"
                                                        v-on:googleLogin="googleLogin($event)"
                                                        :needGoogleLogin="googleView"
                                                    >
                                                </google-login>
                                                <p class="seperator-text" v-show="otpView && googleView && (defaultView === 'google' || defaultView === 'otp')">OR</p>

                                                <otp-login v-show="otpView && showOtp"
                                                    :phoneNumSuccess="phoneNumSuccess"
                                                    v-on:getOtp="getOtp($event)"
                                                    :showResendOTP="showResendOTP"
                                                    v-on:otpLogin="otpLogin($event)"
                                                    :timeCounter="timeCounter">

                                                </otp-login>
                                            </div>
                                            <p class="form-margin" v-if="!googleView && !passwordView && !otpView">
                                                Please enable atleast one mode to setup login!
                                            </p>
                                        </div>
                                         <div class="form-margin invalidSection" v-if="invalidUrl">
                                            <div class="login-err">
                                                <img src="./../assets/images/login-error.png" class="img">
                                            </div>
                                            <p>The good folks at Delhivery say you need to be redirected to this url and not come by yourself, yet!</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="alternate-login-modes" v-if="!isLoading && (passwordView || googleView || otpView || showForgotPassword) && !invalidUrl">
                              <p v-if="passwordView && !showlogin">
                                    Clients:
                                    <a class="link" @click="showAltForm('password')">Login with username</a>
                                </p>
                                <p v-if="(googleView || otpView) && ['password', 'forgot'].indexOf(defaultView) >= 0">
                                    Delhivery employees :
                                    <a class="link" @click="showAltForm('google')">
                                        Login with
                                        <span v-if ="googleView">Delhivery ID</span>

                                        <span v-if="googleView && otpView"> or </span>

                                        <span v-if="otpView"> OTP </span>
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="loadingscreen" v-show="showLoading" >
                <div class="success-spinner otp-spinner"></div>
                <p>Successfully Signed In, Redirecting to the  application
                </p>
            </div>

        </section>
        <p class="copyright-message">
            CONTACT US: +91 (124) 6719500 | COPYRIGHT © DELHIVERY PVT. LTD.
        </p>
    </div>
</template>

<style lang="scss" scoped>
    .login-container{
        position: relative;
    }
    .login{
      text-align : center;
      .delhivery-logo-wrapper{
        left : auto;
      }
    }
    .logofull{
            background-size: 100% auto!important;

    }
    .form-margin{
        &.invalidSection{
            position: absolute;
            top: 10%;
            left: 0;
            right: 0;
            margin: auto;
            height: 265px;
            padding: 10px 10px 0;
            .login-err{
                width: 150px;
                height: 150px;
                margin: 0 auto 40px;
                border: 8px solid #F90018;
                padding: 20px;
                border-radius: 100%;
                img{
                    width: 100%;
                    height : auto;
                }
            }
            p{
                font-size:18px;
                line-height: 28px;
            }
        }
    }
    span{
      &.appName{
        font-size: 26px;
        line-height: 54px;
        display: inline-block;
        border-left: 2px solid;
        margin-left: 10px;
        padding-left:10px;
        vertical-align: middle;
        font-weight: normal;
        font-family: OpenSans-Regular;
        text-transform : uppercase;
        font-style: italic;
      }
    }
    .img{
        width: 100%;
        height: auto;
    }
    .text-uppercase{
      text-transform : uppercase;
    }
    .loadingscreen {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgb(54, 57, 63);
        text-align: center;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        p{
            font-size: 16px;
        }
    }
    .success-spinner {
        box-sizing: border-box;
        height: 60px;
        width: 60px;
        margin: 80px;
        border: 0px solid #f44336;
        border-radius: 50%;
        box-shadow: 0 -20px 0 24px #f44336 inset;
        opacity:1;
        animation: rotate 0.8s infinite linear;
        margin: 0 auto;
        background: #fff;
        &.otp-spinner {
            box-shadow: 0 -20px 0 24px #fff inset;
            border: 0px solid #fff;
            background: #f44336;
        }
    }

    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

</style>

<script>

import ForgotPassword from './ForgotPassword'
import GoogleLogin from './GoogleLogin'
import OtpLogin from './OtpLogin';
import LocalLogin from './LocalLogin'
import Loader from './Loader';
import umsinit from './../mixins/umsinit';
import Errors from './Errors';
import ChangePassword from './ChangePassword'
export default {

  name: 'LoginForm',
  mixins: [ umsinit ],
  data () {
    return {
      showLoading: false,
      defaultView: "google",
      showNoParamsMessage: false,
      googleView: true,
      passwordView: true,
      otpView: true,
      forgotView : false,
      phoneNumorEmailSuccess: false,
      backgroundImage: '',
      deocdeParams : '',
      phoneNo: '',
      showGoogle:'',
      showlogin:'',
      showOtp:'',
      showForgotPassword:'',
      phoneNumSuccess: false,
      showResendOTP : false,
      errorMessage: Object,
      userErrorInfo: Object,
      timeCounter: 10,
      redirectTime: 5,
      isLoading: false,
      phoneNumberEmailSuccess: false,
      invalidUrl: false // invalid url will be true if there is an invalid hash present in the url
    }
  },
  beforeMount() {

      if(this.configOptions.config !== undefined){

          this.defaultView = this.configOptions.config.default;
          this.googleView = this.configOptions.config.google;
          this.otpView = this.configOptions.config.otp;
          this.passwordView = this.configOptions.config.password;
          this.backgroundImage = this.configOptions.bg;
      }

      if(this.defaultView === 'google' || this.defaultView === 'otp'){

          this.showGoogle = true;
          this.showOtp = true;
      }
      if(this.defaultView === 'password'){

          this.showlogin = true;
          this.showForgotPassword = true;

      }
    },
  components: {
    ForgotPassword,
    GoogleLogin,
    OtpLogin,
    LocalLogin,
    Errors,
    ChangePassword,
    Loader
  },
  methods : {

       selectedData(data){
           this.passwordView = false;
       },

       otpLogin($event){

           if($event){
                $event.mobile = this.phoneNo;
                this.otpLoginService($event);
           } else{

               this.errorMessage = { type: 'error', message: 'Otp is required'};
           }

       },
       googleLogin(){

           this.googleLoginService();
       },
       localLogin($event){

          this.localLoginService($event);
       },
       forgotPassword(email){

           this.forgotPasswordService(email);
       },

       goToPage(info) {
           this.goToChangePasswordPage(info);
       }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/LoginForm.vue